var map = {
	"./README.md": 6524,
	"./copy_icons.py": 256,
	"./minerals.jpg": 4244,
	"./other": 3649,
	"./other.ts": 3649,
	"./png/Enhanced_Shockwaves.png": 4448,
	"./png/High_Capacity_Fuel_Tanks.png": 8649,
	"./png/Microbial_Shroud.png": 3457,
	"./png/Tectonic_Destabilizers.png": 1578,
	"./png/btn-ability-protoss-blink-color.png": 8184,
	"./png/btn-ability-protoss-charge-color.png": 6492,
	"./png/btn-ability-protoss-psistorm-color.png": 3439,
	"./png/btn-ability-protoss-stealth-blink.png": 6408,
	"./png/btn-ability-spearofadun-chronosurge-cyberneticscore.png": 4958,
	"./png/btn-ability-spearofadun-chronosurge-darkshrine.png": 7387,
	"./png/btn-ability-spearofadun-chronosurge-fleetbeacon.png": 5636,
	"./png/btn-ability-spearofadun-chronosurge-forge.png": 7209,
	"./png/btn-ability-spearofadun-chronosurge-gateway.png": 8454,
	"./png/btn-ability-spearofadun-chronosurge-nexus.png": 5217,
	"./png/btn-ability-spearofadun-chronosurge-roboticsfacility.png": 1046,
	"./png/btn-ability-spearofadun-chronosurge-roboticssupportbay.png": 6586,
	"./png/btn-ability-spearofadun-chronosurge-stargate.png": 2343,
	"./png/btn-ability-spearofadun-chronosurge-templararchives.png": 7166,
	"./png/btn-ability-spearofadun-chronosurge-twilightcouncil.png": 3529,
	"./png/btn-ability-spearofadun-chronosurge-warpgate.png": 4177,
	"./png/btn-ability-spearofadun-chronosurge.png": 4667,
	"./png/btn-ability-terran-calldownextrasupplies-color.png": 4737,
	"./png/btn-ability-terran-cloak-color.png": 5606,
	"./png/btn-ability-terran-electricfield.png": 3859,
	"./png/btn-ability-terran-emergencythrusters.png": 3149,
	"./png/btn-ability-terran-punishergrenade-color.png": 1478,
	"./png/btn-ability-terran-stimpack-color.png": 2748,
	"./png/btn-ability-terran-yamatogun-color.png": 1105,
	"./png/btn-ability-zerg-burrow-color.png": 9307,
	"./png/btn-ability-zerg-neuralparasite-color.png": 8012,
	"./png/btn-building-nova-barracks.png": 3449,
	"./png/btn-building-nova-starport.png": 3045,
	"./png/btn-building-protoss-assimilator.png": 6494,
	"./png/btn-building-protoss-cyberneticscore.png": 9142,
	"./png/btn-building-protoss-darkshrine.png": 7203,
	"./png/btn-building-protoss-fleetbeacon.png": 2604,
	"./png/btn-building-protoss-forge.png": 5857,
	"./png/btn-building-protoss-gateway.png": 8542,
	"./png/btn-building-protoss-nexus.png": 9721,
	"./png/btn-building-protoss-photoncannon.png": 935,
	"./png/btn-building-protoss-pylon.png": 6928,
	"./png/btn-building-protoss-roboticsfacility.png": 9038,
	"./png/btn-building-protoss-roboticssupportbay.png": 8690,
	"./png/btn-building-protoss-shieldbattery.png": 4078,
	"./png/btn-building-protoss-stargate.png": 4527,
	"./png/btn-building-protoss-templararchives.png": 5638,
	"./png/btn-building-protoss-twilightcouncil.png": 97,
	"./png/btn-building-protoss-warpgate.png": 3161,
	"./png/btn-building-stukov-infestedbarracks.png": 7897,
	"./png/btn-building-stukov-infestedfactory.png": 7436,
	"./png/btn-building-stukov-infestedstarport.png": 6949,
	"./png/btn-building-terran-armory.png": 2000,
	"./png/btn-building-terran-barracks-lift-from-reactor.png": 7397,
	"./png/btn-building-terran-barracks-lift-from-techlab.png": 7602,
	"./png/btn-building-terran-barracks-reactor.png": 4138,
	"./png/btn-building-terran-barracks-techlab.png": 1565,
	"./png/btn-building-terran-barracks-to-free-reactor.png": 2787,
	"./png/btn-building-terran-barracks-to-free-techlab.png": 5976,
	"./png/btn-building-terran-barracks.png": 5679,
	"./png/btn-building-terran-barracksmengsk.png": 4870,
	"./png/btn-building-terran-bunker-salvage.png": 3921,
	"./png/btn-building-terran-bunker.png": 5249,
	"./png/btn-building-terran-commandcenter.png": 3784,
	"./png/btn-building-terran-engineeringbay.png": 9689,
	"./png/btn-building-terran-factory-covertops.png": 9212,
	"./png/btn-building-terran-factory-lift-from-reactor.png": 8368,
	"./png/btn-building-terran-factory-lift-from-techlab.png": 1971,
	"./png/btn-building-terran-factory-reactor.png": 4819,
	"./png/btn-building-terran-factory-techlab.png": 1032,
	"./png/btn-building-terran-factory-to-free-reactor.png": 1486,
	"./png/btn-building-terran-factory-to-free-techlab.png": 5713,
	"./png/btn-building-terran-factory.png": 3574,
	"./png/btn-building-terran-factorymengsk.png": 6031,
	"./png/btn-building-terran-fusioncore.png": 4699,
	"./png/btn-building-terran-ghostacademy.png": 851,
	"./png/btn-building-terran-missileturret.png": 3838,
	"./png/btn-building-terran-planetaryfortress.png": 1078,
	"./png/btn-building-terran-reactor.png": 7802,
	"./png/btn-building-terran-refinery.png": 2178,
	"./png/btn-building-terran-sensordome.png": 2917,
	"./png/btn-building-terran-starport-lift-from-reactor.png": 8617,
	"./png/btn-building-terran-starport-lift-from-techlab.png": 854,
	"./png/btn-building-terran-starport-reactor.png": 7502,
	"./png/btn-building-terran-starport-techlab.png": 7329,
	"./png/btn-building-terran-starport-to-free-reactor.png": 8687,
	"./png/btn-building-terran-starport-to-free-techlab.png": 7364,
	"./png/btn-building-terran-starport.png": 7123,
	"./png/btn-building-terran-starportmengsk.png": 74,
	"./png/btn-building-terran-supplydepot.png": 9685,
	"./png/btn-building-terran-surveillancestation.png": 6577,
	"./png/btn-building-terran-techlab.png": 4301,
	"./png/btn-building-zerg-banelingnest.png": 8090,
	"./png/btn-building-zerg-creeptumor.png": 5352,
	"./png/btn-building-zerg-evolutionchamber.png": 4423,
	"./png/btn-building-zerg-extractor.png": 6006,
	"./png/btn-building-zerg-greaterspire.png": 9947,
	"./png/btn-building-zerg-hatchery.png": 7444,
	"./png/btn-building-zerg-hive.png": 2086,
	"./png/btn-building-zerg-hydraliskden.png": 9460,
	"./png/btn-building-zerg-infestationpit.png": 7753,
	"./png/btn-building-zerg-lair.png": 6784,
	"./png/btn-building-zerg-lurkerden.png": 2588,
	"./png/btn-building-zerg-nydusnetwork.png": 7933,
	"./png/btn-building-zerg-nydusworm.png": 7470,
	"./png/btn-building-zerg-roachwarren.png": 8916,
	"./png/btn-building-zerg-spawningpool.png": 4661,
	"./png/btn-building-zerg-spinecrawler.png": 4267,
	"./png/btn-building-zerg-spire.png": 4407,
	"./png/btn-building-zerg-sporecrawler.png": 6013,
	"./png/btn-building-zerg-ultraliskcavern.png": 7272,
	"./png/btn-extractor-trick.png": 9732,
	"./png/btn-techupgrade-terran-combatshield-color.png": 7205,
	"./png/btn-unit-protoss-adept.png": 2310,
	"./png/btn-unit-protoss-archon.png": 163,
	"./png/btn-unit-protoss-carrier.png": 2794,
	"./png/btn-unit-protoss-colossus.png": 5243,
	"./png/btn-unit-protoss-darktemplar.png": 861,
	"./png/btn-unit-protoss-disruptor.png": 9770,
	"./png/btn-unit-protoss-hightemplar.png": 2293,
	"./png/btn-unit-protoss-immortal.png": 5187,
	"./png/btn-unit-protoss-mothership.png": 5983,
	"./png/btn-unit-protoss-observer.png": 5978,
	"./png/btn-unit-protoss-oracle.png": 5450,
	"./png/btn-unit-protoss-phoenix.png": 3067,
	"./png/btn-unit-protoss-probe.png": 7516,
	"./png/btn-unit-protoss-sentry.png": 8209,
	"./png/btn-unit-protoss-stalker.png": 3230,
	"./png/btn-unit-protoss-tempest.png": 1692,
	"./png/btn-unit-protoss-warpprism.png": 8895,
	"./png/btn-unit-protoss-warpray.png": 3276,
	"./png/btn-unit-protoss-zealot.png": 1701,
	"./png/btn-unit-terran-banshee.png": 5290,
	"./png/btn-unit-terran-battlecruiser.png": 5037,
	"./png/btn-unit-terran-cyclone.png": 709,
	"./png/btn-unit-terran-ghost.png": 7031,
	"./png/btn-unit-terran-hellion.png": 991,
	"./png/btn-unit-terran-hellionbattlemode.png": 6908,
	"./png/btn-unit-terran-liberator.png": 2398,
	"./png/btn-unit-terran-marauder.png": 3419,
	"./png/btn-unit-terran-marine.png": 2306,
	"./png/btn-unit-terran-medivac.png": 6221,
	"./png/btn-unit-terran-mule.png": 9043,
	"./png/btn-unit-terran-raven.png": 3952,
	"./png/btn-unit-terran-reaper.png": 4625,
	"./png/btn-unit-terran-scv.png": 3690,
	"./png/btn-unit-terran-siegetank.png": 1987,
	"./png/btn-unit-terran-thor.png": 2303,
	"./png/btn-unit-terran-vikingfighter.png": 6648,
	"./png/btn-unit-terran-widowmine.png": 1033,
	"./png/btn-unit-zerg-baneling.png": 6450,
	"./png/btn-unit-zerg-broodlord.png": 8059,
	"./png/btn-unit-zerg-corruptor.png": 8116,
	"./png/btn-unit-zerg-drone.png": 1314,
	"./png/btn-unit-zerg-hydralisk.png": 6455,
	"./png/btn-unit-zerg-infestor.png": 4194,
	"./png/btn-unit-zerg-larva.png": 4058,
	"./png/btn-unit-zerg-lurker.png": 6563,
	"./png/btn-unit-zerg-mutalisk.png": 5574,
	"./png/btn-unit-zerg-overlord.png": 9269,
	"./png/btn-unit-zerg-overseer.png": 8793,
	"./png/btn-unit-zerg-queen.png": 5418,
	"./png/btn-unit-zerg-ravager.png": 5838,
	"./png/btn-unit-zerg-roach.png": 1507,
	"./png/btn-unit-zerg-swarmhost.png": 1554,
	"./png/btn-unit-zerg-ultralisk.png": 3697,
	"./png/btn-unit-zerg-viper.png": 332,
	"./png/btn-unit-zerg-zergling.png": 288,
	"./png/btn-upgrade-kerrigan-seismicspines.png": 1918,
	"./png/btn-upgrade-protoss-airarmorlevel1.png": 7098,
	"./png/btn-upgrade-protoss-airarmorlevel2.png": 6993,
	"./png/btn-upgrade-protoss-airarmorlevel3.png": 8600,
	"./png/btn-upgrade-protoss-airweaponslevel1.png": 836,
	"./png/btn-upgrade-protoss-airweaponslevel2.png": 5487,
	"./png/btn-upgrade-protoss-airweaponslevel3.png": 9158,
	"./png/btn-upgrade-protoss-extendedthermallance.png": 3513,
	"./png/btn-upgrade-protoss-fluxvanes.png": 8334,
	"./png/btn-upgrade-protoss-graviticbooster.png": 1697,
	"./png/btn-upgrade-protoss-graviticdrive.png": 269,
	"./png/btn-upgrade-protoss-groundarmorlevel1.png": 8507,
	"./png/btn-upgrade-protoss-groundarmorlevel2.png": 5008,
	"./png/btn-upgrade-protoss-groundarmorlevel3.png": 5561,
	"./png/btn-upgrade-protoss-groundweaponslevel1.png": 953,
	"./png/btn-upgrade-protoss-groundweaponslevel2.png": 2770,
	"./png/btn-upgrade-protoss-groundweaponslevel3.png": 4315,
	"./png/btn-upgrade-protoss-phoenixrange.png": 2652,
	"./png/btn-upgrade-protoss-resonatingglaives.png": 7423,
	"./png/btn-upgrade-protoss-shieldslevel1.png": 4559,
	"./png/btn-upgrade-protoss-shieldslevel2.png": 9284,
	"./png/btn-upgrade-protoss-shieldslevel3.png": 2525,
	"./png/btn-upgrade-terran-advanceballistics.png": 1956,
	"./png/btn-upgrade-terran-buildingarmor.png": 8363,
	"./png/btn-upgrade-terran-caduceusreactor.png": 2503,
	"./png/btn-upgrade-terran-corvidreactor.png": 3175,
	"./png/btn-upgrade-terran-cyclonerangeupgrade.png": 2204,
	"./png/btn-upgrade-terran-highcapacityfueltanks.png": 9593,
	"./png/btn-upgrade-terran-hisecautotracking.png": 564,
	"./png/btn-upgrade-terran-hyperflightrotors.png": 837,
	"./png/btn-upgrade-terran-infantryarmorlevel1.png": 2993,
	"./png/btn-upgrade-terran-infantryarmorlevel2.png": 4010,
	"./png/btn-upgrade-terran-infantryarmorlevel3.png": 4771,
	"./png/btn-upgrade-terran-infantryweaponslevel1.png": 5227,
	"./png/btn-upgrade-terran-infantryweaponslevel2.png": 3248,
	"./png/btn-upgrade-terran-infantryweaponslevel3.png": 8073,
	"./png/btn-upgrade-terran-infernalpreigniter.png": 7908,
	"./png/btn-upgrade-terran-interferencematrix.png": 4091,
	"./png/btn-upgrade-terran-researchdrillingclaws.png": 8444,
	"./png/btn-upgrade-terran-shipweaponslevel1.png": 9188,
	"./png/btn-upgrade-terran-shipweaponslevel2.png": 3839,
	"./png/btn-upgrade-terran-shipweaponslevel3.png": 3862,
	"./png/btn-upgrade-terran-transformationservos.png": 8173,
	"./png/btn-upgrade-terran-vehicleplatinglevel1.png": 22,
	"./png/btn-upgrade-terran-vehicleplatinglevel2.png": 349,
	"./png/btn-upgrade-terran-vehicleplatinglevel3.png": 6452,
	"./png/btn-upgrade-terran-vehicleweaponslevel1.png": 6484,
	"./png/btn-upgrade-terran-vehicleweaponslevel2.png": 1743,
	"./png/btn-upgrade-terran-vehicleweaponslevel3.png": 2726,
	"./png/btn-upgrade-zerg-adaptivetalons.png": 7507,
	"./png/btn-upgrade-zerg-adrenalglands.png": 806,
	"./png/btn-upgrade-zerg-airattacks-level1.png": 3963,
	"./png/btn-upgrade-zerg-airattacks-level2.png": 8928,
	"./png/btn-upgrade-zerg-airattacks-level3.png": 105,
	"./png/btn-upgrade-zerg-anabolicsynthesis.png": 8958,
	"./png/btn-upgrade-zerg-centrifugalhooks.png": 2628,
	"./png/btn-upgrade-zerg-chitinousplating.png": 7293,
	"./png/btn-upgrade-zerg-evolvemuscularaugments.png": 7868,
	"./png/btn-upgrade-zerg-flyercarapace-level1.png": 3120,
	"./png/btn-upgrade-zerg-flyercarapace-level2.png": 2971,
	"./png/btn-upgrade-zerg-flyercarapace-level3.png": 1842,
	"./png/btn-upgrade-zerg-frenzy.png": 7928,
	"./png/btn-upgrade-zerg-glialreconstitution.png": 8403,
	"./png/btn-upgrade-zerg-groovedspines.png": 3210,
	"./png/btn-upgrade-zerg-groundcarapace-level1.png": 9847,
	"./png/btn-upgrade-zerg-groundcarapace-level2.png": 7196,
	"./png/btn-upgrade-zerg-groundcarapace-level3.png": 3109,
	"./png/btn-upgrade-zerg-meleeattacks-level1.png": 1411,
	"./png/btn-upgrade-zerg-meleeattacks-level2.png": 4552,
	"./png/btn-upgrade-zerg-meleeattacks-level3.png": 4497,
	"./png/btn-upgrade-zerg-metabolicboost.png": 7621,
	"./png/btn-upgrade-zerg-missileattacks-level1.png": 2675,
	"./png/btn-upgrade-zerg-missileattacks-level2.png": 1832,
	"./png/btn-upgrade-zerg-missileattacks-level3.png": 897,
	"./png/btn-upgrade-zerg-pathogenglands.png": 6772,
	"./png/btn-upgrade-zerg-pneumatizedcarapace.png": 4346,
	"./png/btn-upgrade-zerg-tunnelingclaws.png": 6196,
	"./png/copy_contents.svg": 3243,
	"./png/icon-gas-protoss-nobg.png": 9588,
	"./png/icon-gas-terran-nobg.png": 3780,
	"./png/icon-mineral-nobg.png": 9662,
	"./png/icon-time-protoss.png": 6925,
	"./png/icon-time-terran.png": 3853,
	"./png/icon-time-zerg.png": 9543,
	"./png/money-symbol-png-icon-17.png": 8009,
	"./png/paste_contents.svg": 9471,
	"./png/sc2_ui_userprofile_ladders_race_icon_protoss.png": 8006,
	"./png/sc2_ui_userprofile_ladders_race_icon_terran.png": 56,
	"./png/sc2_ui_userprofile_ladders_race_icon_zerg.png": 3170,
	"./png/ui-editoricon-data_types_movers.png": 1062,
	"./png/ui-editoricon-previewer_rotateleft.png": 2903,
	"./raceSpecificResource.jpg": 7382,
	"./races": 7333,
	"./races.ts": 7333,
	"./supplyLeft.jpg": 6779,
	"./unit_icons": 9869,
	"./unit_icons.json": 9869,
	"./upgrade_icons": 4419,
	"./upgrade_icons.json": 4419,
	"./vespene.jpg": 9945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8573;